export const ENDPOINTS = {
  apiScanSearch: 'api/search/scan/',
  apiSearchExtendedSurgeryLayer2: 'api/search/extended-surgery-layer2/',
  apiKeywordSearch: 'api/search/text',
  user: 'api/user/',
  welcomeNote: 'api/user/welcome-note/',
  addLog: 'api/user/add-log/',
  getRoleList: 'api/user/role-list/',
  getSpecialtyList: 'api/user/speciality-list/',
  favoriteCodes: 'api/favorite-codes/',
  notes: 'api/notes/',
  getModifiers: 'api/code-modifiers/',
  finalizeNote: 'api/finalize-note/',
  flagCode: 'api/flag-cpt-code/',
  checkCodeCombinations: 'api/code-combinations/',
  searchCodes: 'api/search-codes/',
  adminGetUserLogs: 'api/admin/logs/',
  adminGetFavoriteCodes: 'api/admin/favorite-codes/',
  adminGetFlaggedCodes: 'api/admin/flagged-codes/',
  apiExportPDF: 'api/export-to-pdf',
  adminGetUsers: 'api/admin/users/',
  adminGetUsersQuick: 'api/admin/users/quick',
  adminCreateUser: 'api/admin/users/create',
  adminGetSearchResults: 'api/admin/search-results/',
  adminChangeNoteStatus: 'api/admin/change-note-status/',
  organizations: 'api/organizations/',
  smartEncounter: 'api/smart-encounter/',
  cancelStripeSubscription: 'api/stripe/cancel-subscription/',
  misc: 'api/misc/',
  feeSchedules: 'api/fee-schedules/',
};
